import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import { Classes, Dialog, FormGroup, Button, Intent } from '@blueprintjs/core'
import get from 'lodash/get'

import { SaveAsBlockDialogModel, saveAsBlockDialogModel } from './model'
import AppModel, { NULL as AppModelNULL } from '@client/components/App/model'
import { APP_CONFIG_GET_A_NEWS_LETTER_ORIGIN } from '@config/app.config'
import { SECTION_TYPES_VALUES } from '@client/components/Section/constants'

import './styles.scss'

export class SaveAsBlockDialog extends Component {
  static propTypes = {
    app: PropTypes.instanceOf(AppModel),
    model: PropTypes.instanceOf(SaveAsBlockDialogModel),
    usePortal: PropTypes.bool,
  }

  static defaultProps = {
    app: AppModelNULL,
    model: saveAsBlockDialogModel,
    usePortal: true,
  }

  handleClose = () => {
    const { model } = this.props
    model.hideDialog()
  }

  handeSave = async () => {
    const { model } = this.props
    await model.save()
  }

  handeExit = async () => {
    window.location = `${APP_CONFIG_GET_A_NEWS_LETTER_ORIGIN}/mails/`
  }

  handleChange = (event) => {
    const { model } = this.props
    model.setName(event.target.value)
  }

  render() {
    const { model, app, usePortal } = this.props
    const { formatMessage } = app
    const contentType =
      SECTION_TYPES_VALUES.indexOf(get(model, 'block.type')) !== -1
        ? formatMessage('modal.common.contentType.section')
        : formatMessage('modal.common.contentType.block')
    return (
      <If condition={model.show}>
        <Dialog
          className="save-as-block-dialog"
          icon="add"
          isOpen={model.show}
          onClose={this.handleClose}
          title={formatMessage('modal.saveAsBlock.headerTitle', {
            content_type: contentType,
          })}
          usePortal={usePortal}
        >
          {/* A failed save keeps the form, with the error under it, so the
              user can retry (FE-1489). */}
          {!model.saved && (
            <div className={Classes.DIALOG_BODY}>
              <p>
                {formatMessage('modal.saveAsBlock.formDescription', {
                  content_type: contentType,
                })}
              </p>
              <FormGroup
                label={formatMessage('modal.saveAsBlock.templateNameLabel')}
                helperText={formatMessage(
                  'modal.saveAsBlock.templateNameHelperText',
                  { content_type: contentType }
                )}
                labelFor="template-name"
                required={true}
              >
                <input
                  id="template-name"
                  className="bp6-input bp6-fill"
                  placeholder={formatMessage(
                    'modal.saveAsBlock.templateNamePlaceholder'
                  )}
                  value={model.name}
                  onChange={this.handleChange}
                />
              </FormGroup>
              {model.error && (
                <p className="template-saved-error" role="alert">
                  {formatMessage('modal.saveAsBlock.errorMsg', {
                    content_type: contentType,
                  })}
                  {model.errorDetails && <span> {model.errorDetails}</span>}
                </p>
              )}
            </div>
          )}
          {model.saved && (
            <div className={Classes.DIALOG_BODY}>
              <p className="template-saved-success bp6-ui-text bp6-ui-text-large">
                {formatMessage('modal.saveAsBlock.savedMsg', {
                  content_type: (
                    <span key="1" style={{ textTransform: 'capitalize' }}>
                      {contentType}
                    </span>
                  ),
                })}
              </p>
              <p className="bp6-ui-text bp6-text-muted">
                {formatMessage('modal.saveAsBlock.formDescription.success', {
                  content_type: contentType,
                })}
              </p>
            </div>
          )}
          <div className="bp6-dialog-footer">
            <div className="bp6-dialog-footer-actions">
              {!model.saved && (
                <Button
                  text={formatMessage('modal.common.cancelBtn')}
                  onClick={this.handleClose}
                  disabled={model.saving}
                />
              )}
              {!model.saved && (
                <Button
                  intent={Intent.SUCCESS}
                  onClick={this.handeSave}
                  text={formatMessage('modal.saveAsBlock.saveTemplateBtn', {
                    content_type: contentType,
                  })}
                  loading={model.saving}
                  disabled={!model.canBeSaved}
                />
              )}
              {model.saved && (
                <Button
                  intent={Intent.SUCCESS}
                  onClick={this.handleClose}
                  text={formatMessage('modal.common.continurEditingBtn')}
                />
              )}
            </div>
          </div>
        </Dialog>
      </If>
    )
  }
}

export default inject('app')(observer(SaveAsBlockDialog))
